"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _Link = _interopRequireDefault(require("../../../core/Link"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const Wrapper = exports.Wrapper = /*#__PURE__*/(0, _base.default)(_Link.default, process.env.NODE_ENV === "production" ? {
  target: "ejgzy2n0"
} : {
  target: "ejgzy2n0",
  label: "Wrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "188t3fj",
  styles: "color:white;font-size:16px;font-weight:normal;text-decoration:underline;margin-bottom:6px;cursor:pointer;&:focus{outline:1px dotted white;outline:5px auto -webkit-focus-ring-color;}"
} : {
  name: "188t3fj",
  styles: "color:white;font-size:16px;font-weight:normal;text-decoration:underline;margin-bottom:6px;cursor:pointer;&:focus{outline:1px dotted white;outline:5px auto -webkit-focus-ring-color;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});